export const AdverseMediaPaths = {
  Details: '/adverse-media/$id',
  List: '/adverse-media'
}
